// import companies from './../../../public/map-markers/companies.svg';
// import companiesHover from './../../../public/map-markers/companies-hover.svg';
//
// import education from './../../../public/map-markers/education.svg';
// import educationHover from './../../../public/map-markers/education-hover.svg';
//
// import health from './../../../public/map-markers/health.svg';
// import healthHover from './../../../public/map-markers/health-hover.svg';
//
// import leisure from './../../../public/map-markers/leisure.svg';
// import leisureHover from './../../../public/map-markers/leisure-hover.svg';
//
// import parks from './../../../public/map-markers/parks.svg';
// import parksHover from './../../../public/map-markers/parks-hover.svg';
//
// import restaurantsBars from './../../../public/map-markers/restaurants-bars.svg';
// import restaurantsBarsHover from './../../../public/map-markers/restaurants-bars-hover.svg';
//
// import shops from './../../../public/map-markers/shops.svg';
// import shopsHover from './../../../public/map-markers/shops-hover.svg';
//
// import transportation from './../../../public/map-markers/transportation.svg';
// import transportationHover from './../../../public/map-markers/transportation-hover.svg';

// const icons = {
//     companies: {
//         icon: companies,
//         hover: companiesHover
//     },
//     education: {
//         icon: education,
//         hover: educationHover
//     },
//     health: {
//         icon: health,
//         hover: healthHover
//     },
//     leisure: {
//         icon: leisure,
//         hover: leisureHover
//     },
//     parks: {
//         icon: parks,
//         hover: parksHover
//     },
//     'restaurants-bars': {
//         icon: restaurantsBars,
//         hover: restaurantsBarsHover
//     },
//     shops: {
//         icon: shops,
//         hover: shopsHover
//     },
//     transportation: {
//         icon: transportation,
//         hover: transportationHover
//     }
//
// }

let contactMap

// export default function nearByMap() {
export default async function initMap() {
    const { Map } = await google.maps.importLibrary("maps");

    //map options
    const mapOptions = {
        zoom: 14,
        disableDefaultUI: true,
        scrollwheel: false,
        center: {
            // lat: Number(ajaxObject.mapOptions.main_marker_latitude),
            lat:  52.18545715437994,
            // lng: Number(ajaxObject.mapOptions.main_marker_longitude)
            lng: 21.002085164561095
        },
        styles: [
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e6e4e0"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "saturation": "1"
                    },
                    {
                        "color": "#cee4bf"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.medical",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ead2da"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": "-100"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": "-100"
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#75cff0"
                    }
                ]
            }
        ]

    }
    //new map
    // const contactMap = new google.maps.Map(document.querySelector('#map-near-by'), mapOptions);
    contactMap = new Map(document.getElementById("map-near-by"), mapOptions);
    //image
    const image = {
        url: ajaxObject.mapOptions.main_marker_icon.url,
        size: new google.maps.Size(64, 64),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(0, 40),
        labelOrigin: new google.maps.Point(-64, 30)
    };

    const image2 = {
        url: ajaxObject.mapOptions.main_marker_icon.url,
        size: new google.maps.Size(64, 64),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(0, 40),
        labelOrigin: new google.maps.Point(-88, 30)
    };
    // main marker
    const contactMarker = new google.maps.Marker({
        position:{
            lat: Number(ajaxObject.mapOptions.main_marker_latitude), 
            lng: Number(ajaxObject.mapOptions.main_marker_longitude)
        },
        map: contactMap,
        icon: image,
        label: {
            text: "Sky Living",
            color: "#000000",
            fontSize: "24px",
            fontWeight: "medium"
        }
    });

    const contactMarker2 = new google.maps.Marker({
        position:{
            lat: 52.170965893379226,
            lng: 21.017838270356453
        },
        map: contactMap,
        icon: image2,
        label: {
            text: "Campus Living",
            color: "#000000",
            fontSize: "24px",
            fontWeight: "medium"
        }
    });



    // Events
    const zoomin = document.querySelector('#zoomin');
    const zoomout = document.querySelector('#zoomout');

    zoomout.addEventListener( 'click', () => {
        const currentZoomLevel = contactMap.getZoom();
        if(currentZoomLevel != 0){
            contactMap.setZoom(currentZoomLevel - 1);
        }
    });

    zoomin.addEventListener('click', function() {
        const currentZoomLevel = contactMap.getZoom();
        if(currentZoomLevel != 21){
            contactMap.setZoom(currentZoomLevel + 1);
        }
    });

   
}